import {
  ArrowsChevronUp,
  ArrowsChevronDown,
} from "@fanduel/formation-react-icons";
import { fanduel as fd } from "@fanduel/formation-tokens";
import cx from "classnames";
import { useEffect, useState } from "react";
import { FilterProps } from "@/types/projections";
import styles from "./dropdownLegacy.module.scss";

const Dropdown = ({
  value,
  options,
  setValue,
  label,
}: FilterProps & { label: string }) => {
  const [isVisible, toggleDropdown] = useState(true);
  const selected = options.find((option) => option.value === value);
  const containerClass = cx(styles.container, {
    [styles.active]: isVisible,
  });

  useEffect(() => {
    toggleDropdown(false);
  }, [value]);

  return (
    <div suppressHydrationWarning className={containerClass}>
      <p className={styles.dropdownLabel}>{label}</p>
      <button
        className={styles.button}
        type="button"
        onClick={() => toggleDropdown((val) => !val)}
      >
        <span>{selected?.label}</span>
        {isVisible ? (
          <ArrowsChevronUp color={fd.colors.coreBlueD1} />
        ) : (
          <ArrowsChevronDown color={fd.colors.coreBlueD1} />
        )}
      </button>
      {isVisible && (
        <ul className={styles.list}>
          {options.map((option) => (
            <li className={styles.listItem} key={option.slug}>
              <input
                hidden
                type="radio"
                onChange={() => setValue(option.value)}
                id={option.slug}
                name={label}
                value={option.value}
                defaultChecked={
                  JSON.stringify(value) === JSON.stringify(option.value)
                }
              />
              <label htmlFor={option.slug}>{option.label}</label>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Dropdown;
